import {Component, HostBinding, HostListener, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import {ImageCarouselComponent} from '../image-carousel/image-carousel.component';
import {IPicture} from '@api/models/image/picture';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';

@Component({
  selector: 'lib-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent {

  public resolution = IMAGE_RESOLUTION.HIGH;
  @Input() public images: IPicture[] = [];
  @Input() public index: number;
  @Output() public galleryClose = new EventEmitter();
  @Output() public imageChange = new EventEmitter();
  @HostBinding('class.active') @Input() public active = false;
  @ViewChild('carouselComponent', {static: true}) private carousel: ImageCarouselComponent;

  constructor() { }

  public open(index: number): void {
    this.carousel.changeImage(index);
    this.active = true;
  }

  public close(): void {
    this.galleryClose.emit();
    this.active = false;
  }

  @HostListener('click')
  private onClick(): void {
    this.close();
  }

  @HostListener('document:keydown.escape', ['$event'])
  private onKeydownHandler() {
    this.close();
  }
}
